module.exports = __webpack_public_path__ + "img/shop1.58eaa26d.png";